import { fetchData } from "./fetchData";

export const getUTCTimeAPI = async() => {
    const route = '/utils/utctime';

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}